import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "antd";
import "../MortgageCalculators/RateQuote.css";
import "../MortgageCalculators/RateQuoteNew.css";
import "./PPEPricing.css";
import SearchBox from "./components/search/index";
import { RecentSearchesButton } from "./components/search/RecentSearches";
import { checkAccess } from "../../Auth";
import { UR_Owner } from "../../State";
import Lenders from "../../Management/Lenders";
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

// PPEPricing mirrors the legacy Rates tool's page chrome (RateQuoteNew): a top
// header bar with title + actions (48px since UI-3 of plan ppe-ui-option-b), and the #f6f6f6 gray content area
// (.rate-quote-new-content) that the white search/result cards sit on. The
// LO/Borrower version toggle is intentionally omitted — PPE is a single unified
// engine with no separate borrower version. The body reuses a FORKED copy of the
// Rates SearchBox whose fetch points at the new unified pricing endpoint; the
// real Rates tool (MortgageCalculators) is untouched.
export default function PPEPricing() {
  // The search picked from the header's Recent searches list; a new object
  // each pick, so picking the same search twice reruns it twice.
  const [recent, setRecent] = useState(null);
  const [addLenderModal, setAddLenderModal] = useState(false);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    track(STATSIG.COMMON.VIEW, PAGE.RATES, { page: PAGE.RATES })
  }, [])

  return (
    <div className="rate-quote-new ppe-pricing">
      {/* Page header: the title, Add lenders (owners) and the Recent searches
          icon (plan ppe-ui-option-b, UI-3). */}
      <header className="ppe-page-header">
        {!isMobile && <h1 className="ppe-page-title">Rates</h1>}
        <div className="ppe-page-actions">
          {checkAccess([UR_Owner]) && (
            <button
              type="button"
              className="ppe-btn ppe-btn-secondary"
              onClick={() => {
                track(STATSIG.RATES.ADD_LENDERS_BUTTON, 'click_open_popup', { type: 'click_open_popup' })
                setAddLenderModal(true)
              }}
            >
              Add lenders
            </button>
          )}
          <RecentSearchesButton
            onOpen={() => track(STATSIG.RATES.RECENT_SEARCH_BUTTON, 'click_open_popup', { type: 'click_open_popup' })}
            onPick={(parameters) => {
              track(STATSIG.RATES.RECENT_SEARCH_BUTTON, 'item_open', { type: 'item_open' })
              setRecent({ parameters })
            }}
          />
        </div>
      </header>

      {/* Scroll area with the gray content background. */}
      <div className="ppe-page-scroll">
        <div className="rate-quote-new-content">
          <SearchBox recent={recent} />
        </div>
      </div>

      <Modal
        open={addLenderModal}
        onCancel={() => setAddLenderModal(false)}
        centered
        footer={[
          <Button key="back" onClick={() => setAddLenderModal(false)}>
            Cancel
          </Button>,
        ]}
        width={1200}
      >
        <Lenders statsigSource="rates" />
      </Modal>
    </div>
  );
}
